// Utilitaire de tri partagé pour toutes les listes de personnel du site.
// Tri par rôle (hiérarchie du cabinet) puis par nom de famille, puis prénom.

const ROLE_ORDER = {
  "Directeur": 0,
  "Super-Admin": 0,
  "Manager": 1,
  "Médecin": 2,
  "Medecin": 2,
  "Assistant": 3,
  "Secrétaire": 4,
  "Secretaire": 4,
  "Correspondant": 5,
};

const roleRank = (role) => {
  if (role == null) return 99;
  const r = ROLE_ORDER[role];
  return r === undefined ? 90 : r;
};

const norm = (s) => (s || "").toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().toLowerCase();

// Compare deux membres du personnel : rôle puis nom puis prénom.
export const compareStaff = (a, b) => {
  const ra = roleRank(a?.role);
  const rb = roleRank(b?.role);
  if (ra !== rb) return ra - rb;
  const na = norm(a?.nom);
  const nb = norm(b?.nom);
  const cmpNom = na.localeCompare(nb, "fr");
  if (cmpNom !== 0) return cmpNom;
  return norm(a?.prenom).localeCompare(norm(b?.prenom), "fr");
};

// Compare deux membres du personnel : rôle puis prénom puis nom.
export const compareStaffByPrenom = (a, b) => {
  const ra = roleRank(a?.role);
  const rb = roleRank(b?.role);
  if (ra !== rb) return ra - rb;
  const cmpPrenom = norm(a?.prenom).localeCompare(norm(b?.prenom), "fr");
  if (cmpPrenom !== 0) return cmpPrenom;
  return norm(a?.nom).localeCompare(norm(b?.nom), "fr");
};

// Renvoie une copie triée (par rôle puis nom) sans muter l'entrée.
export const sortStaff = (list) => [...(list || [])].sort(compareStaff);

// Filtre de recherche insensible casse/accents sur nom + prénom (+ rôle/email).
export const matchStaff = (emp, query) => {
  if (!query || !query.trim()) return true;
  const q = norm(query);
  const txt = norm(`${emp?.prenom || ""} ${emp?.nom || ""} ${emp?.role || ""} ${emp?.email || ""}`);
  return txt.includes(q);
};
